import { render, staticRenderFns } from "./about.vue?vue&type=template&id=25371ce2&scoped=true"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"
import style0 from "./about.vue?vue&type=style&index=0&id=25371ce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25371ce2",
  null
  
)

export default component.exports